module.exports = __webpack_public_path__ + "img/ring_y_s_1_null.cb75b020.png";